<template>
  <InboxErrorNotice
    :notice="notice"
    :message="errorMessage"
    :title="objectTitle ?? undefined"
    @archived="$emit('archived', $event)"
  />
</template>

<script lang="ts">
import { computed, defineComponent, PropType, shallowRef } from "vue";

import InboxErrorNotice from "@/components/inbox/InboxErrorNotice.vue";
import {
  getNoticeObjectTableTitle,
  getNoticeObjectTitle,
  integrationErrorCode,
  integrationErrorObjectId,
  type IntegrationErrorNotice,
} from "@/components/inbox/notice";
import * as inject from "@/components/inject";

export default defineComponent({
  name: "InboxIntegrationErrorNotice",
  components: { InboxErrorNotice },
  props: {
    notice: {
      type: Object as PropType<IntegrationErrorNotice>,
      required: true,
    },
  },
  emits: {
    archived: (_noticeId: string) => true,
  },
  setup(props) {
    const controller = inject.controller();

    const objectTitle = shallowRef<string | null>(null);
    const tableTitle = shallowRef<string | null>(null);

    const errorMessage = computed(() => {
      const errorCode = integrationErrorCode(props.notice);
      const errorMap: Record<string, string> = {
        create_record_failed:
          "Couldn't create: the integration rejected the change; reverted",
        update_record_failed:
          "Couldn't update: the integration rejected the change; reverted",
        delete_record_failed:
          "Couldn't delete: the integration rejected the change; reverted",
      };
      const message = errorMap[errorCode] || props.notice.message;
      return tableTitle.value ? `${message} in ${tableTitle.value}` : message;
    });

    getNoticeObjectTitle(
      integrationErrorObjectId(props.notice),
      controller
    ).then((title) => {
      objectTitle.value = title;
    });
    getNoticeObjectTableTitle(
      integrationErrorObjectId(props.notice),
      controller
    ).then((title) => {
      tableTitle.value = title;
    });

    return {
      errorMessage,
      objectTitle,
    };
  },
});
</script>
